import { defineMessages } from 'react-intl'

const messages = defineMessages({
  espanol: {
    id: 'LanguageController.espanol',
    description: 'Español',
    defaultMessage: 'Español'
  },
  euskera: {
    id: 'LanguageController.euskera',
    description: 'Euskera',
    defaultMessage: 'Euskera'
  },
  english: {
    id: 'LanguageController.english',
    description: 'English',
    defaultMessage: 'English'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/Controllers/Language/LanguageController/messages.js